// Sick certificate input modal — extracted from the old inline panel.
// Owns its own form state; raises (payload) to the caller on submit.

import { useState } from 'react'
import Modal, { Field, ModalActions, PrimaryButton, SecondaryButton } from './Modal.jsx'

export default function SickCertModal({ onClose, onSubmit, submitting }) {
  const today = new Date().toISOString().slice(0, 10)
  const [days, setDays] = useState(3)
  const [start, setStart] = useState(today)
  const [unfitFor, setUnfitFor] = useState('all duties')
  const [includeDx, setIncludeDx] = useState(false)
  const [extra, setExtra] = useState('')

  return (
    <Modal
      title="Sick Certificate"
      subtitle="Auto-filled from this encounter; adjust the duration and certify."
      onClose={onClose}
    >
      <Field label="Days off">
        <input
          type="number" min={1} max={90}
          value={days}
          onChange={(e) => setDays(Math.max(1, Number(e.target.value) || 1))}
          className="border-2 border-slate-200 focus:border-wantok-600 focus:outline-none rounded-lg px-3 py-2 w-28 font-semibold text-base"
        />
      </Field>
      <Field label="First day off">
        <input
          type="date"
          value={start}
          onChange={(e) => setStart(e.target.value)}
          className="border-2 border-slate-200 focus:border-wantok-600 focus:outline-none rounded-lg px-3 py-2 text-base"
        />
      </Field>
      <Field label="Unfit for">
        <select
          value={unfitFor}
          onChange={(e) => setUnfitFor(e.target.value)}
          className="border-2 border-slate-200 focus:border-wantok-600 focus:outline-none rounded-lg px-3 py-2 text-base"
        >
          <option value="all duties">All duties</option>
          <option value="heavy lifting">Heavy lifting</option>
          <option value="prolonged standing">Prolonged standing</option>
          <option value="school attendance">School attendance</option>
          <option value="driving">Driving</option>
        </select>
      </Field>
      <Field label="Privacy">
        <label className="flex items-center gap-2 cursor-pointer select-none">
          <input
            type="checkbox"
            checked={includeDx}
            onChange={(e) => setIncludeDx(e.target.checked)}
            className="w-4 h-4 accent-wantok-700"
          />
          <span className="text-sm text-slate-700">Include diagnosis on certificate (off by default)</span>
        </label>
      </Field>
      <Field label="Extra notes (optional)">
        <textarea
          rows={2}
          value={extra}
          onChange={(e) => setExtra(e.target.value)}
          className="border-2 border-slate-200 focus:border-wantok-600 focus:outline-none rounded-lg px-3 py-2 text-sm w-full"
          placeholder="Any specific instructions for the patient or employer"
        />
      </Field>

      <ModalActions>
        <SecondaryButton onClick={onClose} disabled={submitting}>Cancel</SecondaryButton>
        <PrimaryButton
          onClick={() =>
            onSubmit({
              days_off: days,
              start_date: start,
              unfit_for: unfitFor,
              include_diagnosis: includeDx,
              certificate_text: extra || undefined,
            })
          }
          disabled={submitting}
        >
          {submitting ? 'Generating…' : 'Generate certificate'}
        </PrimaryButton>
      </ModalActions>
    </Modal>
  )
}
